module.exports = new __parcel__URL__("maxime-baconnais.ad0bee28.jpeg").toString();